import axios from 'axios';

export default {
  data() {
    return {
      currentHash: '{{POST_BUILD_ENTERS_HASH_HERE}}',
      hashChanged: false,
      newHash: ''
    }
  },
  methods: {
    initVersionCheck(url, frequency = 1000 * 60 * 2) { // default frequency = 2 minutes
      this.checkVersion(url);
      setInterval(() => {
        this.checkVersion(url);
      }, frequency);
    },
    async checkVersion(url) {
      axios.get(url + '?t=' + new Date().getTime())
        .then((response) => {
          this.newHash = response.data.hash;
          this.hashChanged = this.currentHash !== this.newHash;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    reloadApp() {
      this.currentHash = this.newHash;
      window.location.reload(true);
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/refresh-page.mixin.js